/* src/app/app.component.scss */
ion-list {
  background: transparent;
}
ion-item {
  --background: transparent !important;
  --padding-start: 0px;
  --inner-padding-start: 0px;
  --border-color: black !important;
}
.side-menu-icon {
  margin-left: 10px;
  font-size: 20px;
}
ion-text {
  color: #505050;
  padding-left: 5px;
}
ion-footer {
  background: #eeeeee;
}
.my-custom-menu {
  --width: 50%;
}
ion-toolbar {
  --background:#12457b;
}
img {
  height: 70px;
  width: 70px;
  margin: 10px;
  border-radius: 50% !important;
}
::ng-deep ion-button {
  text-transform: initial;
  border-radius: 0px;
}
.item,
.list,
.item-content,
.item-complex {
  --ion-background-color: red !important;
}
ion-footer {
  background: #505050 !important;
}
/*# sourceMappingURL=app.component.css.map */
